import { ActionIcon, Modal, SegmentedControl, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCloudUpload } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import ZapierContent from "./ZapierContent";
import { useSessionStore } from "../../../../../stores/UserStore";
import { useState } from "react";
import MakeContent from "./make/MakeContent";

const ZapierSettings = ({ type = "prm", disabled, ...props }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [tab, setTab] = useState("zapier");

  return (
    <>
      <Tooltip label={lang.sync_zapier.dialog_title}>
        <ActionIcon
          variant="light"
          size={36}
          radius={"md"}
          onClick={open}
          disabled={disabled}
          {...props}
        >
          <IconCloudUpload />
        </ActionIcon>
      </Tooltip>

      <Modal
        opened={opened}
        onClose={close}
        title={lang.sync_zapier.dialog_title}
        size={
          useSessionStore.getState().reseller?.name === "Magileads"
            ? "100%"
            : "60%"
        }
      >
        {type === "prm" && (
          <SegmentedControl
            data={[
              {
                label: lang.sync_zapier.sync_zapier,
                value: "zapier",
              },
              {
                label: lang.sync_zapier.sync_make,
                value: "make",
              },
            ]}
            value={tab}
            onChange={setTab}
            size="md"
            mb={"lg"}
            w={"100%"}
          />
        )}
        {tab === "zapier" ? (
          <ZapierContent type={type} handleClose={close} />
        ) : (
          <MakeContent handleClose={close} />
        )}
      </Modal>
    </>
  );
};

export default ZapierSettings;
